import { z } from "zod";

/** GET/PUT /v1/me/profile — web "Hesap ve ayarlar" (K-124) */
export interface ProfileView {
  email: string | null;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
  theme: "light" | "dark";
  /** misafir hesap (K-049): yalnızca e-posta kodu ile girer */
  isGuest: boolean;
}

const Name = z.string().trim().min(1).max(80);
export const UpdateProfileBody = z
  .object({
    firstName: Name.nullable(),
    lastName: Name.nullable(),
    /** uluslararası biçim; doğrulama (SMS) ayrı akış */
    phone: z
      .string()
      .trim()
      .regex(/^\+[0-9][0-9 ()-]{5,24}$/)
      .nullable(),
    theme: z.enum(["light", "dark"]),
  })
  .partial()
  .refine((b) => Object.keys(b).length > 0, { message: "empty" });
export type UpdateProfileBody = z.infer<typeof UpdateProfileBody>;

/** POST /v1/auth/email-status — giriş formunun ikinci adımı (K-130): şifreli hesap → şifre, değilse → e-posta kodu */
export const EmailStatusBody = z.object({
  email: z.string().trim().toLowerCase().email().max(255),
});
export type EmailStatusBody = z.infer<typeof EmailStatusBody>;
export interface EmailStatusResponse {
  /** yalnızca "şifre koymuş, silinmemiş hesap var mı"; hesap yoksa ile şifresizse aynı cevap (false) */
  hasPassword: boolean;
}
